import Vue from 'vue';
import Router from 'vue-router';
import Form from './components/Form.vue';
import Movies from './components/Movies.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/add',
      name: 'Form',
      component: Form,
    },
    {
      path: '/add/:url',
      name: 'Form',
      component: Form,
    },
    {
      path: '/',
      name: 'Movies',
      component: Movies,
    },
    {
      path: '/movies/:id',
      name: 'Movies',
      component: Movies,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './components/HelloWorld.vue'),
    },
  ],
});
